import React, { useState } from "react";
import {
  Mail,
  Phone,
  MapPin,
  Upload,
  CheckCircle2,
  FileText,
  AlertTriangle,
  ChevronDown,
  Loader2,
  Send,
  X,
  ExternalLink,
  ShieldCheck,
  Building,
  Sparkles,
  RefreshCw
} from "lucide-react";
import DxLogo from "../assets/DxLogo.svg";

const WEBHOOK_URL ="https://api-prod.dexkor.com/api/v1/salescrm/webhook?token=49812a89a3c8e1bb11c46adde1e5feed:d9c9781e9bd8f7c473784582bf726acdd76f6cc603de4197f155f4f7dcaa23adffa9476da332f627ecb772cf1ea20a56dcabcf355292c0c60d2b83302b2600867b2e2af8741947a249d14af07bd09f1a0519bb82d703a5665fc20456451c7b36df24513b67c2ffb0193e317c720a49e18f8d7ab430bf81d713311a41f9d7752e5343da215bf37722f7eb6862a0b1afa4d7baddec7b2637077b4ad11356879f13b5d85fbb0e7157914207441caa9a1c75a8e64aad22e04adfaf8af252b236955de8869eca7cbd35fb3ac88e96985effbd5c303fe1baf9c3bc9ca10d6afa058d98f2237aeb1fb461cfb46a97:c041b5535e5c59c764fa217ca1b52811"


const ATTACHMENT_API =
  (process.env.REACT_APP_CHAT_MICROSERVICE_URL || "https://api-prod.dexkor.com/api/v1") +
  "/attachment";

const COUNTRIES = [
  "United States",
  "India",
  "United Kingdom",
  "Canada",
  "Australia",
  "Germany",
  "France",
  "Singapore",
  "United Arab Emirates",
  "Netherlands",
  "Japan",
  "Brazil",
  "Other"
];

const INDUSTRIES = [
  "Technology & SaaS",
  "Financial Services & FinTech",
  "Healthcare & Life Sciences",
  "E-Commerce & Retail",
  "Manufacturing & Logistics",
  "Telecommunications",
  "Consulting & Professional Services",
  "Education & EdTech",
  "Media & Entertainment",
  "Other"
];

const EMPLOYEE_SIZES = [
  "1-10 employees",
  "11-50 employees",
  "51-200 employees",
  "201-500 employees",
  "501-1,000 employees",
  "1,000+ employees"
];

const ANNUAL_REVENUES = [
  "Pre-revenue / < $100K",
  "$100K - $1M",
  "$1M - $5M",
  "$5M - $20M",
  "$20M - $50M",
  "$50M+"
];

const INTEREST_LEVELS = ["High", "Medium", "Low", "Urgent / Immediate POC"];

const INTERESTED_MODULES = [
  "SalesCRM",
  "Customer Success & Health Score",
  "Omnichannel HelpDesk",
  "Agentic AI (Ask Dexy)",
  // "Telemetry & Analytics",
  "Partner Portal"
];

const INITIAL_FORM = {
  name: "",
  email: "",
  phone: "",
  companyName: "",
  website: "",
  industry: "Technology & SaaS",
  employee_size: "11-50 employees",
  annual_revenue: "$1M - $5M",
  country: "United States",
  state: "",
  city: "",
  region: "",
  intreset_level: "High",
  domain: "",
  notes: "",
  contactName: "",
  contactTitle: "",
  contactEmail: "",
  contactMobile: "",
  contactPhone: "",
  lead_source: "Website Landing Page",
  lead_sub_source: "Contact & Demo Form",
  lead_status: "New",
  channel: "Web",
 
};

const LandingPage = () => {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [selectedModules, setSelectedModules] = useState([
    "SalesCRM",
    "Agentic AI (Ask Dexy)"
  ]);
  const [files, setFiles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({
    type: null,
    title: "",
    message: "",
    details: ""
  });
  const [uploadProgress, setUploadProgress] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === "name" && !prev.contactName) updated.contactName = value;
      if (name === "email" && !prev.contactEmail) updated.contactEmail = value;
      if (name === "phone" && !prev.contactMobile) updated.contactMobile = value;
      return updated;
    });
  };

  const handleModuleToggle = (moduleName) => {
    setSelectedModules((prev) =>
      prev.includes(moduleName)
        ? prev.filter((m) => m !== moduleName)
        : [...prev, moduleName]
    );
  };

  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files || []);
    if (selected.length + files.length > 5) {
      alert("You can upload a maximum of 5 attachments.");
      return;
    }
    setFiles((prev) => [...prev, ...selected]);
  };

  const removeFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const uploadAttachments = async () => {
    if (files.length === 0) return [];
    setUploadProgress(`Uploading ${files.length} document(s)...`);
    const uploadedUrls = [];

    for (const file of files) {
      try {
        const data = new FormData();
        data.append("attachment", file);

        const res = await fetch(ATTACHMENT_API, {
          method: "POST",
          body: data
        });

        if (res.ok) {
          const json = await res.json();
          if (json?.data?.url) {
            uploadedUrls.push(json.data.url);
          } else if (json?.url) {
            uploadedUrls.push(json.url);
          }
        } else {
          console.warn("Attachment upload response status:", res.status);
        }
      } catch (err) {
        console.warn("Attachment upload warning (skipping file):", file.name, err);
      }
    }
    return uploadedUrls;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim() || !formData.email.trim() || !formData.companyName.trim()) {
      setSubmitStatus({
        type: "error",
        title: "Required Information Missing",
        message: "Please complete Company Name, Full Name, and Work Email.",
        details: ""
      });
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus({ type: null, title: "", message: "", details: "" });

    try {
      // 1. Upload any attachments first
      const uploadedAttachmentUrls = await uploadAttachments();

      // 2. Prepare comprehensive payload
      const combinedNotes = [
        formData.notes.trim(),
        selectedModules.length > 0 ? `Selected Modules: ${selectedModules.join(", ")}` : "",
        uploadedAttachmentUrls.length > 0
          ? `Attachments (${uploadedAttachmentUrls.length}): ${uploadedAttachmentUrls.join(", ")}`
          : ""
      ]
        .filter(Boolean)
        .join("\n\n");

      const payload = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        phone: (formData.phone || formData.contactMobile || "").trim(),
        companyName: formData.companyName.trim(),
        industry: formData.industry,
        country: formData.country,
        notes: combinedNotes,
        annual_revenue: formData.annual_revenue,
        lead_status: formData.lead_status || "New",
        state: formData.state.trim(),
        region: formData.region.trim(),
        website: formData.website.trim(),
        city: formData.city.trim(),
        employee_size: formData.employee_size,
        intreset_level: formData.intreset_level,
        domain:
          formData.domain.trim() ||
          (formData.website ? formData.website.replace(/https?:\/\//, "").split("/")[0] : ""),
        channel: formData.channel,
        contactName:formData.name.trim(),
        lead_source: formData.lead_source,
        contactEmail: formData.email.trim(),
        lead_sub_source: formData.lead_sub_source,
        contactMobile: formData.phone.trim(),
        
        contactPhone:formData.phone.trim(),
       
        contactTitle: formData.contactTitle.trim(),
        
        attachments: uploadedAttachmentUrls
      };

      const res = await fetch(WEBHOOK_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        let errDetail = "";
        try {
          const errJson = await res.json();
          errDetail = errJson.message || errJson.error || JSON.stringify(errJson);
        } catch (_) {
          errDetail = `HTTP ${res.status} ${res.statusText}`;
        }
        throw new Error(errDetail || `Webhook returned status ${res.status}`);
      }

      setSubmitStatus({
        type: "success",
        title: "Lead Successfully Registered",
        message:
          "Thank you! Your information has been synced directly into Dexkor SalesCRM. Our enterprise team will be in touch shortly.",
        details: ""
      });

      // Reset form fields, modules and attachments
      setFormData(INITIAL_FORM);
      setSelectedModules(["SalesCRM", "Agentic AI (Ask Dexy)"]);
      setFiles([]);
    } catch (err) {
      console.error("Submission failed:", err);
      setSubmitStatus({
        type: "error",
        title: "Submission Error",
        message:
          "We were unable to deliver your lead payload to the SalesCRM webhook. Please double-check your network or retry below.",
        details: err?.message || String(err)
      });
    } finally {
      setIsSubmitting(false);
      setUploadProgress("");
    }
  };

  const handleResetForm = () => {
    setFormData(INITIAL_FORM);
    setFiles([]);
    setSubmitStatus({ type: null, title: "", message: "", details: "" });
  };

  return (
    <div className="min-h-screen bg-slate-100/70 text-slate-800 font-sans p-3 sm:p-6 lg:p-8 flex items-center justify-center">
      <div className="w-full max-w-6xl mx-auto bg-white rounded-xl shadow-lg border border-slate-200/90 overflow-hidden">
        {/* Compact Enterprise Brand Header */}
        <div className="bg-gradient-to-r from-slate-900 via-slate-800 to-indigo-950 text-white px-5 py-4 sm:px-8 sm:py-5 flex flex-wrap items-center justify-between gap-3 border-b border-slate-700">
          <div className="flex items-center gap-3.5">
            <div className="bg-white/10 p-1.5 rounded-lg border border-white/10 backdrop-blur-xs flex items-center justify-center">
              <img src={DxLogo} alt="Dexkor" className="h-6 sm:h-7 w-auto object-contain brightness-0 invert" />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <span className="font-bold text-base sm:text-lg tracking-tight">Enterprise Lead Application</span>
                <span className="hidden sm:inline-block px-2 py-0.5 text-[10px] uppercase font-bold tracking-wider bg-blue-500/20 text-blue-300 rounded border border-blue-400/30">
                  SalesCRM Inbound
                </span>
              </div>
              <p className="text-xs text-slate-300 hidden sm:block">
                Direct integration with Dexkor Revenue Operations Suite
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4 text-xs">
            <a
              href="https://dexkor.com"
              target="_blank"
              rel="noreferrer"
              className="text-slate-300 hover:text-white transition flex items-center gap-1 font-medium"
            >
              dexkor.com
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
          </div>
        </div>

        {/* Content Area: Form (2 Cols on desktop) + Quick Sidebar */}
        <div className="grid grid-cols-1 lg:grid-cols-12 divide-y lg:divide-y-0 lg:divide-x divide-slate-200">
          {/* Main Form Body */}
          <div className="lg:col-span-8 p-5 sm:p-7 lg:p-8">
            {/* Status Notification Banner */}
            {submitStatus.type && (
              <div
                className={`mb-6 p-4 rounded-lg flex items-start gap-3 border transition-all ${
                  submitStatus.type === "success"
                    ? "bg-emerald-50 border-emerald-300 text-emerald-900"
                    : "bg-rose-50 border-rose-300 text-rose-900"
                }`}
              >
                {submitStatus.type === "success" ? (
                  <CheckCircle2 className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5" />
                ) : (
                  <AlertTriangle className="w-5 h-5 text-rose-600 shrink-0 mt-0.5" />
                )}
                <div className="flex-1 text-xs sm:text-sm">
                  <div className="flex items-center justify-between gap-2">
                    <p className="font-bold">{submitStatus.title}</p>
                    {submitStatus.type === "success" && (
                      <button
                        type="button"
                        onClick={handleResetForm}
                        className="text-emerald-700 hover:text-emerald-900 font-semibold underline text-xs flex items-center gap-1"
                      >
                        <RefreshCw className="w-3 h-3" />
                        Submit another
                      </button>
                    )}
                  </div>
                  <p className="mt-0.5 leading-relaxed">{submitStatus.message}</p>
                  {submitStatus.details && (
                    <p className="mt-1 text-[11px] font-mono bg-rose-100/60 p-1.5 rounded border border-rose-200 text-rose-800 break-all">
                      Error details: {submitStatus.details}
                    </p>
                  )}
                </div>
                <button
                  type="button"
                  onClick={() => setSubmitStatus({ type: null, title: "", message: "", details: "" })}
                  className="text-slate-400 hover:text-slate-600 p-0.5"
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-4.5">
              {/* Row 1: Company Name & Website */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1">
                    Company Name <span className="text-rose-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      name="companyName"
                      required
                      placeholder="e.g. Acme Corporation"
                      value={formData.companyName}
                      onChange={handleChange}
                      className="w-full px-3 py-2 text-sm rounded-md border border-slate-300 text-slate-900 placeholder-slate-400 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-slate-50/40 hover:bg-white transition"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1">
                    Website URL
                  </label>
                  <input
                    type="text"
                    name="website"
                    placeholder="https://acme.com"
                    value={formData.website}
                    onChange={handleChange}
                    className="w-full px-3 py-2 text-sm rounded-md border border-slate-300 text-slate-900 placeholder-slate-400 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-slate-50/40 hover:bg-white transition"
                  />
                </div>
              </div>

              {/* Row 2: Solutions of Interest */}
              <div>
                <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1.5">
                  Interested Modules <span className="text-slate-400 font-normal lowercase">(select all that apply)</span>
                </label>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                  {INTERESTED_MODULES.map((module) => {
                    const checked = selectedModules.includes(module);
                    return (
                      <label
                        key={module}
                        className={`flex items-center gap-2 p-2 rounded-md border text-xs cursor-pointer select-none transition ${
                          checked
                            ? "bg-blue-50/80 border-blue-400 text-blue-900 font-semibold"
                            : "bg-white border-slate-200 text-slate-600 hover:bg-slate-50"
                        }`}
                      >
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() => handleModuleToggle(module)}
                          className="w-3.5 h-3.5 text-blue-600 rounded border-slate-300 focus:ring-0"
                        />
                        <span className="truncate">{module}</span>
                      </label>
                    );
                  })}
                </div>
              </div>

              {/* Section Divider */}
              <div className="pt-2 border-t border-slate-200">
                <span className="text-[11px] font-bold uppercase tracking-wider text-slate-400">
                  Primary Contact Person
                </span>
              </div>

              {/* Row 3: Full Name & Job Title */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1">
                    Full Name <span className="text-rose-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    placeholder="John Doe"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-3 py-2 text-sm rounded-md border border-slate-300 text-slate-900 placeholder-slate-400 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-slate-50/40 hover:bg-white transition"
                  />
                </div>

                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1">
                    Job Title / Role
                  </label>
                  <input
                    type="text"
                    name="contactTitle"
                    placeholder="VP Revenue / Head of CX"
                    value={formData.contactTitle}
                    onChange={handleChange}
                    className="w-full px-3 py-2 text-sm rounded-md border border-slate-300 text-slate-900 placeholder-slate-400 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-slate-50/40 hover:bg-white transition"
                  />
                </div>
              </div>

              {/* Row 4: Work Email & Phone */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1">
                    Work Email <span className="text-rose-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="john@acme.com"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-3 py-2 text-sm rounded-md border border-slate-300 text-slate-900 placeholder-slate-400 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-slate-50/40 hover:bg-white transition"
                  />
                </div>

                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1">
                    Direct Phone / Mobile
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="+1 (555) 019-2834"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-3 py-2 text-sm rounded-md border border-slate-300 text-slate-900 placeholder-slate-400 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-slate-50/40 hover:bg-white transition"
                  />
                </div>
              </div>

              {/* Section Divider */}
              <div className="pt-2 border-t border-slate-200">
                <span className="text-[11px] font-bold uppercase tracking-wider text-slate-400">
                  Firmographics & Location
                </span>
              </div>

              {/* Row 5: Country & City/State */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3.5">
                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1">
                    Country <span className="text-rose-500">*</span>
                  </label>
                  <div className="relative">
                    <select
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      className="w-full px-3 py-2 text-sm rounded-md border border-slate-300 text-slate-900 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-slate-50/40 hover:bg-white appearance-none cursor-pointer pr-8 transition"
                    >
                      {COUNTRIES.map((c) => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                    </select>
                    <ChevronDown className="w-4 h-4 text-slate-400 absolute right-2.5 top-2.5 pointer-events-none" />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1">
                    City
                  </label>
                  <input
                    type="text"
                    name="city"
                    placeholder="San Francisco"
                    value={formData.city}
                    onChange={handleChange}
                    className="w-full px-3 py-2 text-sm rounded-md border border-slate-300 text-slate-900 placeholder-slate-400 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-slate-50/40 hover:bg-white transition"
                  />
                </div>

                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1">
                    State / Region
                  </label>
                  <input
                    type="text"
                    name="state"
                    placeholder="California / CA"
                    value={formData.state}
                    onChange={handleChange}
                    className="w-full px-3 py-2 text-sm rounded-md border border-slate-300 text-slate-900 placeholder-slate-400 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-slate-50/40 hover:bg-white transition"
                  />
                </div>
              </div>

              {/* Row 6: Industry, Scale, Revenue, Interest */}
              <div className="grid grid-cols-1 sm:grid-cols-4 gap-3.5">
                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1">
                    Industry
                  </label>
                  <div className="relative">
                    <select
                      name="industry"
                      value={formData.industry}
                      onChange={handleChange}
                      className="w-full px-3 py-2 text-sm rounded-md border border-slate-300 text-slate-900 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-slate-50/40 hover:bg-white appearance-none cursor-pointer pr-8 transition"
                    >
                      {INDUSTRIES.map((ind) => (
                        <option key={ind} value={ind}>
                          {ind}
                        </option>
                      ))}
                    </select>
                    <ChevronDown className="w-4 h-4 text-slate-400 absolute right-2.5 top-2.5 pointer-events-none" />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1">
                    Employee Size
                  </label>
                  <div className="relative">
                    <select
                      name="employee_size"
                      value={formData.employee_size}
                      onChange={handleChange}
                      className="w-full px-3 py-2 text-sm rounded-md border border-slate-300 text-slate-900 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-slate-50/40 hover:bg-white appearance-none cursor-pointer pr-8 transition"
                    >
                      {EMPLOYEE_SIZES.map((sz) => (
                        <option key={sz} value={sz}>
                          {sz}
                        </option>
                      ))}
                    </select>
                    <ChevronDown className="w-4 h-4 text-slate-400 absolute right-2.5 top-2.5 pointer-events-none" />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1">
                    Annual Revenue
                  </label>
                  <div className="relative">
                    <select
                      name="annual_revenue"
                      value={formData.annual_revenue}
                      onChange={handleChange}
                      className="w-full px-3 py-2 text-sm rounded-md border border-slate-300 text-slate-900 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-slate-50/40 hover:bg-white appearance-none cursor-pointer pr-8 transition"
                    >
                      {ANNUAL_REVENUES.map((rev) => (
                        <option key={rev} value={rev}>
                          {rev}
                        </option>
                      ))}
                    </select>
                    <ChevronDown className="w-4 h-4 text-slate-400 absolute right-2.5 top-2.5 pointer-events-none" />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1">
                    Urgency / POC
                  </label>
                  <div className="relative">
                    <select
                      name="intreset_level"
                      value={formData.intreset_level}
                      onChange={handleChange}
                      className="w-full px-3 py-2 text-sm rounded-md border border-slate-300 text-slate-900 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-slate-50/40 hover:bg-white appearance-none cursor-pointer pr-8 transition"
                    >
                      {INTEREST_LEVELS.map((lvl) => (
                        <option key={lvl} value={lvl}>
                          {lvl}
                        </option>
                      ))}
                    </select>
                    <ChevronDown className="w-4 h-4 text-slate-400 absolute right-2.5 top-2.5 pointer-events-none" />
                  </div>
                </div>
              </div>

              {/* Row 7: Notes & Project Scope */}
              <div>
                <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1">
                  Project Notes & Stack Requirements
                </label>
                <textarea
                  rows={2}
                  name="notes"
                  placeholder="Outline current tools (e.g. Salesforce, HubSpot, Slack), user seats, key goals..."
                  value={formData.notes}
                  onChange={handleChange}
                  className="w-full px-3 py-2 text-sm rounded-md border border-slate-300 text-slate-900 placeholder-slate-400 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-slate-50/40 hover:bg-white transition resize-y"
                />
              </div>

              {/* Row 8: Attachments Upload */}
              <div className="bg-slate-50 border border-slate-200/90 rounded-lg p-3">
                <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
                  <div className="flex items-center gap-1.5">
                    <Upload className="w-3.5 h-3.5 text-blue-600" />
                    <span className="text-xs font-bold text-slate-700 uppercase tracking-wider">
                      Attach RFP / Deck / Specs
                    </span>
                  </div>
                  <span className="text-[11px] text-slate-500">Max 5 files (PDF, DOCX, XLSX, PNG, JPG)</span>
                </div>

                <div className="flex items-center gap-3">
                  <label className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white hover:bg-slate-50 border border-slate-300 text-slate-700 rounded-md text-xs font-semibold cursor-pointer shadow-2xs transition">
                    <FileText className="w-3.5 h-3.5 text-slate-500" />
                    <span>Choose Files</span>
                    <input type="file" multiple onChange={handleFileChange} className="hidden" />
                  </label>

                  <div className="text-xs text-slate-500 truncate">
                    {files.length === 0 ? "No files selected" : `${files.length} file(s) attached`}
                  </div>
                </div>

                {files.length > 0 && (
                  <div className="mt-2.5 flex flex-wrap gap-1.5">
                    {files.map((file, idx) => (
                      <span
                        key={idx}
                        className="inline-flex items-center gap-1.5 px-2 py-1 bg-white border border-slate-200 rounded text-xs text-slate-700"
                      >
                        <span className="max-w-[180px] truncate">{file.name}</span>
                        <button
                          type="button"
                          onClick={() => removeFile(idx)}
                          className="text-slate-400 hover:text-rose-500"
                        >
                          <X className="w-3 h-3" />
                        </button>
                      </span>
                    ))}
                  </div>
                )}

                {uploadProgress && (
                  <div className="mt-2 flex items-center gap-1.5 text-xs text-blue-600 font-medium">
                    <Loader2 className="w-3.5 h-3.5 animate-spin" />
                    <span>{uploadProgress}</span>
                  </div>
                )}
              </div>

              {/* Action Buttons */}
              <div className="pt-2 flex flex-col sm:flex-row items-center justify-between gap-3">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full sm:w-auto px-7 py-2.5 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-bold rounded-lg text-sm shadow-sm transition disabled:opacity-60 flex items-center justify-center gap-2 cursor-pointer"
                >
                  {isSubmitting ? (
                    <>
                      <Loader2 className="w-4 h-4 animate-spin" />
                      <span>Submitting to SalesCRM...</span>
                    </>
                  ) : (
                    <>
                      <Send className="w-4 h-4" />
                      <span>Submit Lead Application</span>
                    </>
                  )}
                </button>

                <p className="text-[11px] text-slate-400 text-center sm:text-right">
                  Secured with end-to-end webhook encryption & SOC2 Type II compliance.
                </p>
              </div>
            </form>
          </div>

          {/* Right Sidebar: Contact & Enterprise Info (Compact) */}
          <div className="lg:col-span-4 p-5 sm:p-7 bg-slate-50/60 flex flex-col justify-between space-y-6">
            <div className="space-y-5">
              {/* Head office quick card */}
              <div className="bg-white p-4 rounded-xl border border-slate-200/90 shadow-2xs">
                <span className="text-[10px] font-bold uppercase tracking-wider text-blue-600 block mb-2">
                  Headquarters & Sales
                </span>
                <div className="space-y-2.5 text-xs text-slate-600">
                  <div className="flex items-start gap-2">
                    <MapPin className="w-3.5 h-3.5 text-slate-400 shrink-0 mt-0.5" />
                    <span>Dexkor HQ, Innov8 Orchid Center, Sector 53, Gurugram, India</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Mail className="w-3.5 h-3.5 text-slate-400 shrink-0" />
                    <a href="mailto:contact@dexkor.com" className="text-blue-600 hover:underline font-medium">
                      contact@dexkor.com
                    </a>
                  </div>
                  <div className="flex items-center gap-2">
                    <Phone className="w-3.5 h-3.5 text-slate-400 shrink-0" />
                    <span className="font-semibold text-slate-700">+1 (800) 339-5670</span>
                  </div>
                </div>

                <div className="mt-3.5 pt-3 border-t border-slate-100 flex gap-2">
                  <a
                    href="mailto:sales@dexkor.com?subject=Enterprise%20Inquiry"
                    className="flex-1 text-center py-1.5 px-2 bg-amber-400 hover:bg-amber-500 text-slate-950 font-bold text-[11px] rounded transition"
                  >
                    Direct Email
                  </a>
                  <button
                    type="button"
                    onClick={() => {
                      const launcherBtn = document.querySelector(".dexkor-chat-launcher");
                      if (launcherBtn) launcherBtn.click();
                    }}
                    className="flex-1 text-center py-1.5 px-2 bg-slate-100 hover:bg-slate-200 text-slate-800 font-semibold text-[11px] rounded transition"
                  >
                    Ask Dexy AI
                  </button>
                </div>
              </div>

              {/* Enterprise Guarantee */}
              <div className="bg-slate-900 text-white p-4 rounded-xl shadow-xs">
                <div className="flex items-center gap-2 mb-2">
                  <ShieldCheck className="w-4 h-4 text-emerald-400" />
                  <span className="text-xs font-bold text-white">Enterprise Ready</span>
                </div>
                <p className="text-[11px] text-slate-300 leading-relaxed mb-3">
                  Dexkor powers mission-critical revenue ops with real-time webhooks, automated lead scoring, and bi-directional CRM syncing.
                </p>
                <div className="space-y-1.5 text-[11px] text-slate-300">
                  <div className="flex items-center gap-1.5">
                    <Sparkles className="w-3 h-3 text-blue-400 shrink-0" />
                    <span>Real-time webhook sync</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <Building className="w-3 h-3 text-emerald-400 shrink-0" />
                    <span>Multi-tenant SaaS support</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <ShieldCheck className="w-3 h-3 text-purple-400 shrink-0" />
                    <span>GDPR & SOC 2 aligned</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Footer Note */}
            <div className="text-[11px] text-slate-400 border-t border-slate-200 pt-3 flex items-center justify-between">
              <span>© {new Date().getFullYear()} Dexkorcrm Inc.</span>
              <a href="https://dexkor.com" target="_blank" rel="noreferrer" className="hover:text-slate-600 transition">
                Privacy & Terms
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;